<template>
  <b-container>
    <create-account-form with-access @created="onAccountCreated"></create-account-form>
  </b-container>
</template>

<script>

  export default {
    data() {
        return {
        }
    },
        methods: {
            onAccountCreated() {
                this.$router.push("ConfirmationInscription")
            }
        },
    }
</script>

<style>

</style>